<template>
  <v-card>
    <v-row class="pt-4 px-3 ma-0">
      <v-col
        cols="12"
        md="2"
      >
        <v-text-field
          v-model="filter.search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          outlined
          width="20"
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-select
          v-model="filter.state"
          label="Filter by state"
          outlined
          dense
        >
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-select
          v-model="filter.lga"
          label="Filter by Lga"
          outlined
          dense
        >
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-text-field
          v-model="filter.phone"
          append-icon="mdi-magnify"
          label="Filter by Phone"
          single-line
          outlined
          width="20"
          dense
          hide-details
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-text-field
          v-model="filter.gender"
          append-icon="mdi-magnify"
          label="Filter Gender"
          single-line
          outlined
          width="20"
          dense
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="farmers"
      show-select
    >
      <template v-slot:top>
        <v-toolbar flat colour="white">
          <v-toolbar-title>Farmers</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="ma-2"
            text
            >
              <v-icon left>mdi-filter</v-icon>
                filter
            </v-btn>
            <v-btn
            color="primary"
            class="ma-2"
            text
            >
              <v-icon left>mdi-download</v-icon>
                Export
            </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.photo`] = "{ item }">
        <v-avatar size="30">
          <img :src= "`http://localhost:5000/${item.photo}`" lazy-src="../assets/avatar.jpg">
        </v-avatar>
      </template>
      <!--fullname//////////////-->
      <template v-slot:[`item.full_name`] = "{ item }">
        {{ item.first_name }} {{ item.last_name }}
      </template>
      <template v-slot:[`item.actions`] = "{ item }">
        <v-btn
          color="primary"
          class="ml-n2"
          depressed
          small
          @click="editFarmer(item._id)"
        >
          More
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// import FarmerService from '../services/FarmerService'
// import { oyolga } from '../utils/Statelga'
export default {
  data () {
    return {
      search: '',
      lga: '',
      phone: '',
      gender: '',
      filter: {
        search: '',
        state: '',
        lga: '',
        phone: '',
        gender: '',
        enumeratorid: ''
      },
      enumeratorid: '',
      error: '',
      selected: [],
      headers: [
        {
          text: '',
          align: 'start',
          value: 'photo',
          sortable: false
        },
        { text: 'Farmers', value: 'full_name' },
        { text: 'Phone', value: 'phone' },
        { text: 'Gender', value: 'gender' },
        { text: 'Age', value: 'age' },
        { text: 'Qualification', value: 'edu_qua' },
        { text: 'State', value: 'state' },
        { text: 'Field LGA', value: 'lga' },
        { text: 'Actions', value: 'actions' }
      ],
      farmers: [
        {
          first_name: 'Faithful',
          last_name: 'Ojebiyi',
          gender: 'M',
          age: '40',
          edu_qua: 'BSc',
          state: 'Oyo',
          lga: 'Afijio'
        }
      ]
    }
  },
  /* async mounted () {
    try {
      const query = {
        enumeratorid: this.$route.query.enumeratorid,
        search: this.search,
        lga: this.lga,
        phone: this.phone,
        gender: this.gender
      }
      for (const k in query) if (!query[k]) delete query[k]
      console.log(query.enumeratorid)
      this.farmers = await FarmerService.getFarmers()
    } catch (err) {
      this.error = err.message
    }
  }, */
  /* methods: {
    editFarmer (id) {
      this.$router.push({ name: 'Farmer', params: { id: id } })
    },
    async updateQuery () {
      const query = Object.entries(this.filter).reduce((acc, [key, val]) => {
        if (!val) return acc
        return { ...acc, [key]: val }
      }, {})
      console.log(query)
      /* this will update your URL query based on toggled values.
        Be sure to update the Name to what your actual route is */
  /* if (Object.entries(query).length === 0 && query.constructor === Object) {
        this.farmers = await FarmerService.getFarmers()
      } else if ('enumeratorid' in query && !('search' in query || 'lga' in query || 'phone' in query || 'gender' in query)) {
        this.farmers = await FarmerService.getFarmers(query)
      } else if ('enumeratorid' in query && ('search' in query || 'lga' in query || 'phone' in query || 'gender' in query)) {
        clearTimeout(this._timer)
        this.$router.replace({ name: 'Farmerstable', query: { ...query } })
        this.farmers = []
        this._timer = setTimeout(function () {
          this.fetchData()
        }.bind(this), 1000)
      } else {
        this.$router.replace({ name: 'Farmerstable', query: { ...query } })
        clearTimeout(this._timer)
        this.farmers = []
        this._timer = setTimeout(function () {
          this.fetchData()
        }.bind(this), 1000)
      }
    },
    async fetchData () {
      const query = Object.entries(this.filter).reduce((acc, [key, val]) => {
        if (!val) return acc
        return { ...acc, [key]: val }
      }, {})
      this.farmers = await FarmerService.getFarmers(query)
    }
  }, */
  /* watch: {
    '$route.path': {
      immediate: true,
      async handler (enumerator) {
        const query = {
          enumeratorid: this.$route.query.enumeratorid,
          search: this.search,
          lga: this.lga,
          phone: this.phone,
          gender: this.gender
        }
        for (const k in query) if (!query[k]) delete query[k]
        console.log(query.enumeratorid)
        this.farmers = await FarmerService.getFarmers(query)
      }
    }
  } */
  /* watch: {
    '$route.query.enumeratorid': {
      immediate: true,
      async handler (enumeratorid) {
        console.log(enumeratorid)
        this.farmers = await FarmerService.getFarmers(enumeratorid)
      }
    }
  } */
  watch: {
    '$route.path': {
      immediate: true,
      async handler () {
        this.updateQuery()
      }
    },
    '$route.query.search': {
      immediate: true,
      async handler (value) {
        this.filter.search = value
      }
    },
    '$route.query.enumeratorid': {
      immediate: true,
      async handler (value) {
        console.log(value)
        this.filter.enumeratorid = value
        this.updateQuery()
      }
    },
    '$route.query.state': {
      immediate: true,
      async handler (value) {
        this.filter.state = value
      }
    },
    '$route.query.phone': {
      immediate: true,
      async handler (value) {
        this.filter.phone = value
      }
    },
    '$route.query.lga': {
      immediate: true,
      async handler (value) {
        this.filter.lga = value
      }
    },
    '$route.query.gender': {
      immediate: true,
      async handler (value) {
        this.filter.gender = value
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
